// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3HFKU","footer":"ModalFilter_footer__1CcJH"};